export enum EnumHolidayType {
    QUOTE = "quote",
    BOOK = "book"
}